function Legal() {
  return (
    <section className="generalContainer">
      <div className="generalBackground light-bg">
        <h2 className="section-title">Legal Notice</h2>
        <ul className="legalNoticeList">
          <li className="legalNoticeElement">
            You are currently connected to the website www.z-team.herokuapp.com
            (hereinafter the "Site") published by the organization Z-TEAM, a
            non-profit association (law 1901), registered with the
            Boulogne-Billancourt Town Hall , whose registered office is located
            at 95 ALLEE DU FORUM , 92100 Boulogne-Billancurt and whose
            publication director is Mr.AKIL IHSSANE. The Site is hosted by
            www.heroku.com.
          </li>
          <li className="legalNoticeElement">
            If you have any questions, please contact us at the following
            address: contact@z-team.fr. The fact of accessing and browsing the
            Site constitutes your unreserved acceptance of the following
            provisions: WARRANTIES AND LIABILITY Z-Team makes every effort to
            ensure that the information accessible through the Site is accurate
            and up-to-date. However, Z-Team does not guarantee in any way that
            this information is accurate, complete and up-to-date. Z-Team
            provides no guarantee, express or tacit, concerning all or part of
            the Site and also declines any responsibility concerning the access
            and the content of the Site.
          </li>
          <li className="legalNoticeElement">
            Under no circumstances can Z-Team be held liable for any direct or
            indirect damage, whatever the cause, origin, nature and consequence,
            arising from the consultation or use of the Site. In particular,
            Z-Team declines all responsibility in the event of interruption or
            inaccessibility of the Site, the occurrence of bugs or any damage
            resulting from fraudulent acts by third parties (such as intrusions)
            from the Site.
          </li>
          <li className="legalNoticeElement">
            The organization declines all responsibility for the content of the
            linked sites. Whatever the type of link established from an external
            website, known as a “linking site”, to that of Z-Team.fr, the latter
            reserves the right to oppose its establishment. INTELLECTUAL
            PROPERTY The photographs, texts, illustrations, logos, files
            available for download, database appearing on the site, general
            structure of the site, slogans, drawings, images, videos, animated
            sequences with or without sound as well as all works integrated into
            the site are the property of Z-Team or of third parties having
            authorized Z-Team to use them.
          </li>
          <li className="legalNoticeElement">
            Reproductions, on paper or computer, of the said site and the works
            reproduced therein are authorized provided that they are strictly
            reserved for personal use excluding any use for other purposes. With
            the exception of the above provisions, any reproduction,
            representation, use or modification, by any process whatsoever and
            on any medium whatsoever, of all or part of the site, of all or part
            of the various works that compose it , without having obtained the
            prior authorization of Z-Team is strictly prohibited and constitutes
            an offense of counterfeiting and may give rise to civil and/or
            criminal legal proceedings and the payment of damages. DISPUTES
            These terms are established in accordance with French law and in
            particular the provisions of the law of June 21, 2004 on confidence
            in the digital economy.
          </li>
          <li className="legalNoticeElement">
            The French courts have territorial jurisdiction to hear any dispute
            relating to the Site. UPDATE OF THE LEGAL NOTICES Z-TEAM
            organization reserves the right to update these legal notices at any
            time, depending on the evolution of the content of the site and
            legal and regulatory developments. Z-Team therefore invites all
            users to visit this page each time they consult the Site in order to
            familiarize themselves with it.
          </li>
        </ul>
      </div>
    </section>
  );
}

export default Legal;
